<script>
	// libraries
	import { descending } from 'd3-array'

	// components
	import BarChart from './components/BarChart.svelte'
	import MoreLess from './components/MoreLess.svelte'
	import Buttons from './components/Buttons.svelte'

	// other
	import { dataAidOct, dataAidTotalOct } from './data'
	import { formatFloat } from './utils'

	const total = dataAidTotalOct.total
	// ui

	let more = false

	let norm = 'abs'
	$: key = 'total_' + norm
	$: subkeys = ['bilat_' + norm, 'eu_' + norm]

	let sorting = []

	$: {
		sorting = dataAidOct.map((x) => ({ iso_a2: x.iso_a2, value: x[key] }))
		sorting.sort((a, b) => descending(a.value, b.value))
		sorting = sorting.map((x) => x.iso_a2)
	}

	const frmtFull = {
		abs: formatFloat({
			digits: 2,
			adaptive: true,
			decimal: true,
			postfix: ' Mrd. EUR'
		}),
		pop: formatFloat({
			digits: 1,
			adaptive: true,
			decimal: true,
			postfix: ' EUR / Kopf'
		}),
		gdp: formatFloat({ digits: 2, adaptive: true, decimal: true, postfix: '%' })
	}
	const frmtShort = {
		abs: formatFloat({ digits: 2, adaptive: true, decimal: true, postfix: '' }),
		pop: formatFloat({ digits: 1, adaptive: true, decimal: true, postfix: '' }),
		gdp: formatFloat({ digits: 2, adaptive: true, decimal: true, postfix: '%' })
	}

	const firstInsides = {
		abs: true,
		pop: true,
		gdp: false
	}

	const paddingRights = {
		abs: 0,
		pop: 10,
		gdp: 43
	}

	$: paddingRight = paddingRights[norm]
	$: firstInside = firstInsides[norm]

	$: formatFunctionFull = frmtFull[norm]
	$: formatFunctionShort = frmtShort[norm]

	let elemMain

	const optionsNorm = [
		{ label: 'absolut', value: 'abs' },
		{ label: 'pro Kopf', value: 'pop' },
		{ label: 'in % des BIP', value: 'gdp' }
	]

	const sublabels = ['Direkte bilaterale Hilfen', 'Hilfen über die EU']
	const subcolors = ['#88A8BA', '#334CA4']
</script>

<div class="aid-chart" bind:this={elemMain}>
	<div class="heading">
		<div class="main">Internationale Unterstützung für die Ukraine</div>
		<div class="subheading" style="color: #9b9b9b">
			Bisherige Gesamtsumme zugesagter Hilfen: <span style="color: #727272"
				>{frmtFull.abs(total)}</span>
		</div>
	</div>

	<Buttons options={optionsNorm} bind:value={norm} />

	<div class="bar-chart-container">
		<BarChart
			data={dataAidOct}
			{key}
			{subkeys}
			{formatFunctionFull}
			{formatFunctionShort}
			{sorting}
			{sublabels}
			{subcolors}
			{firstInside}
			{paddingRight}
			limit={more ? 0 : 10}
			widthMeta={125} />
	</div>

	<MoreLess bind:more scrollToElement={elemMain} />

	<div class="caption">
		<b>Die zugesagten Hilfen pro Land</b> umfassen finanzielle, humanitäre und
		militärische Unterstützung. Die Daten umfassen den Zeitraum vom 24.1. bis
		zum 3.10.
		<div class="attribution">
			Daten: <a
				href="https://www.ifw-kiel.de/de/themendossiers/krieg-gegen-die-ukraine/ukraine-support-tracker/"
				target="_blank">Ukraine Support Tracker, IfW Kiel</a>
		</div>
	</div>
</div>

<style lang="scss">
	@import 'main.scss';

	.aid-chart {
		font-family: $ff-sans;
		font-size: 17px;
		line-height: 23px;
		font-weight: normal;
		color: #000;

		@media (max-width: 480px) {
			font-size: 16px;
			line-height: 22px;
		}
	}

	.bar-chart-container {
		margin: 20px 0 15px 0;
	}

	.heading .main {
		font-family: $ff-serif;
		font-size: 22px;
		line-height: 30px;
		font-weight: bold;
		margin-bottom: 5px;

		@media (max-width: 480px) {
			font-size: 20px;
			line-height: 24px;
		}
	}

	.caption {
		color: #9b9b9b;
		margin-top: 20px;

		b {
			font-weight: 500;
		}
	}

	.subheading {
		font-weight: 600;
		margin: 0 0 20px 0;
	}

	.attribution {
		display: inline;

		a {
			text-decoration: underline !important;
			color: #9b9b9b !important;
			background: none !important;
			text-shadow: none !important;
		}
	}
</style>
